import { render, staticRenderFns } from "./ItemsInInvoice.vue?vue&type=template&id=6508dd7f&"
import script from "./ItemsInInvoice.vue?vue&type=script&lang=js&"
export * from "./ItemsInInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports